'use client';

//import bg from '../../../../public/images/background.svg';
import AxiosInstance from '../../utils/axiosInstance';
import Image from "next/image";
import { useState, useEffect } from "react";
import ButtonComponent from '../../components/Button';
export default function Register() {
  const [selectedGender, setSelectedGender] = useState('');
  const [selectedAge, setSelectedAge] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [citySuggestions, setCitySuggestions] = useState<Array<{
    nom: string;
    code: string;
    codesPostaux: string[];
  }>>([]);
  const [isTeacher, setIsTeacher] = useState(false);
  const [errors, setErrors] = useState({
    gender: false,
    age: false,
    city: false
  });
  const [showSuggestions, setShowSuggestions] = useState(false);
  const searchCities = async (search: string) => {
    if (search.length < 2) {
      setCitySuggestions([]);
      setShowSuggestions(false);
      return;
    }
    try {
      const response = await fetch(`https://geo.api.gouv.fr/communes?nom=${search}&limit=5&boost=population&fields=nom,code,codesPostaux`);
      const data = await response.json();
      setCitySuggestions(data);
      setShowSuggestions(true);
    } catch (error) {
      console.error('Erreur lors de la recherche des villes:', error);
      setCitySuggestions([]);
    }
  };
  const handleSelectGender = (gender: string) => {
    setSelectedGender(gender);
    setErrors({
      ...errors,
      gender: false
    });
  };
  const handleAge = (event: any) => {
    const value = event.target.value;
    // Empêcher les valeurs négatives
    if (value === '' || Number(value) >= 1 && Number(value) <= 120) {
      setSelectedAge(value);
      setErrors({
        ...errors,
        age: false
      });
    }
  };
  const handleCity = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedCity(value);
    setErrors({
      ...errors,
      city: false
    });
    searchCities(value);
  };
  const handleSelectCity = (city: {
    nom: string;
    codesPostaux: string[];
    selectedCodePostal?: string;
  }) => {
    const cityWithPostalCode = `${city.nom}, ${city.selectedCodePostal || city.codesPostaux[0]}`;
    setSelectedCity(cityWithPostalCode);
    setShowSuggestions(false);
    setCitySuggestions([]);
    setErrors({
      ...errors,
      city: false
    });
  };
  useEffect(() => {
    const handleClickOutside = () => {
      setShowSuggestions(false);
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  const handleTeacher = (event: any) => {
    setIsTeacher(!event.target.checked);
  };
  const handleSubmit = async () => {
    const ageNumber = Number(selectedAge);
    const isAgeValid = selectedAge && ageNumber >= 1 && ageNumber <= 120;
    const newErrors = {
      gender: !selectedGender,
      age: !isAgeValid,
      city: !selectedCity
    };
    setErrors(newErrors);
    if (Object.values(newErrors).some(error => error)) {
      alert("Veuillez remplir tous les champs obligatoires avec des valeurs valides.");
      return;
    }
    try {
      const response = await AxiosInstance.post('/users', {
        teacher: isTeacher,
        city: selectedCity,
        age: selectedAge,
        gender: selectedGender
      });
      if (response.data?.data?.id) {
        localStorage.setItem('userId', response.data.data.code);
        document.cookie = `userId=${response.data.data.code}`;
        window.location.href = "/consultation/form";
      } else {
        alert("Erreur serveur.");
      }
    } catch (error: any) {
      console.log(error.message);
    }
  };
  const genders = {
    'female': "Une femme",
    'man': "Un homme",
    "n/a": "Je préfère ne pas répondre"
  };
  return <div className="bg-fixed bg-cover bg-center p-8 h-full" data-sentry-component="Register" data-sentry-source-file="page.tsx">
            <div className='max-w-screen-lg mx-auto flex flex-col items-center'>
                <div className="w-[60%] md:w-[250px] my-4 md:mt-8 md:mb-4">
                        <Image src="/images/logo.svg" alt="logo-ecole-ideale" width={300} height={300} className="w-full" data-sentry-element="Image" data-sentry-source-file="page.tsx" />
                </div>
                <p className="text-center pt-10 pb-4">
                    Cette consultation citoyenne est anonyme et ouverte à tou(te)s. A des fins uniquement statistiques, nous vous demandons de répondre aux 4 questions suivantes. Nous vous remercions !
                </p>
                <div className="w-full mt-8 grid gap-8">
                    <div className=" grid gap-6">
                        <h2 className="font-poppins font-bold text-lg">Êtes-vous* :</h2>
                        {Object.entries(genders).map(([key, value]) => {
            return <div key={value}>
                                <p onClick={() => handleSelectGender(key)} className={`cursor-pointer border border-black rounded inline p-2 ${selectedGender === key ? "bg-black text-white" : "hover:bg-black hover:text-white"} ${errors.gender && !selectedGender ? "border-red-500" : "border-black"}`}>
                                    {value}
                                </p>
                            </div>;
          })}
                    </div>
                    <div className="grid gap-4 mt-2">
                        <h2 className="font-poppins font-bold text-lg">Quel est votre âge* ?</h2>
                        <div className="flex">
                            <input placeholder="35" type="number" min="1" max="120" className={`border border-black rounded py-1 pl-2 ${errors.age && !selectedAge ? "border-red-500" : "border-black"}`} onChange={handleAge}></input>
                            <p className="pl-2 pt-1">ans</p>
                        </div>
                    </div>
                    <div className="grid gap-4">
                        <h2 className="font-poppins font-bold text-lg">Dans quelle ville vivez-vous* ?</h2>
                        <div className="flex flex-col relative">
                            <input type="text" value={selectedCity} className={`border border-black rounded py-1 pl-2 w-64 ${errors.city && !selectedCity ? "border-red-500" : "border-black"}`} onChange={handleCity} onClick={e => e.stopPropagation()} placeholder="Aubervilliers" />
                            {showSuggestions && citySuggestions.length > 0 && <div className="absolute top-full left-0 w-64 bg-white border border-gray-300 rounded mt-1 max-h-48 overflow-y-auto z-10 shadow-lg">
                                    {citySuggestions.flatMap(city => city.codesPostaux.map(codePostal => <div key={`${city.code}-${codePostal}`} className="px-3 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => handleSelectCity({
                ...city,
                selectedCodePostal: codePostal
              })}>
                                                {`${city.nom}, ${codePostal}`}
                                            </div>))}
                                </div>}
                        </div>
                    </div>
                    <div className="flex">
                        <input type="checkbox" className="mr-4 accent-black" onChange={handleTeacher}></input>
                        <h2 className="font-poppins font-bold text-lg">Je suis enseignant(e)</h2>
                    </div>
                </div>
                <div className="flex gap-8 pt-12">
                <ButtonComponent href="/consultation" variant="white" text="PRECÉDENT" data-sentry-element="ButtonComponent" data-sentry-source-file="page.tsx"></ButtonComponent>
                <ButtonComponent variant="black" text="SUIVANT" onClick={handleSubmit} data-sentry-element="ButtonComponent" data-sentry-source-file="page.tsx"></ButtonComponent>
                </div>
                <a href="/consultation/login"><p className="cursor-pointer underline mb-8 mt-8 text-gray-500">J'ai déjà un code participant</p></a>
            </div>
        </div>;
}